import axios from 'axios';
import { SELFMOVEIN_URI } from './apiVersionConstants';

export default {
    async getMoveInCost(request) {
        return axios.get(`${SELFMOVEIN_URI}/getmoveincost?rentableinventoryid=${request.rentableInventoryId}&addonid=${request.addOnId}&istaxexempt=${request.isTaxExempt}&locationTimeZone=${request.locationTimeZone}`);
    }
};